export default "__VITE_ASSET__a9e21f5d__"